
import { Users, Shield, BarChart4, Heart, UserCheck } from "lucide-react";

const BookAudience = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 mb-6 text-sm font-medium bg-green-100 text-green-800 rounded-full">
              Who Should Read This
            </span>
            <h2 className="text-4xl font-avenir font-bold mb-6">
              Who This Book Is For
            </h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="flex items-center mb-4">
                <Users className="h-6 w-6 text-amber-500 mr-3" />
                <h3 className="text-xl font-medium">Entrepreneurs considering co-founders or key partners</h3>
              </div>
              <p className="text-gray-600">
                Learn how to evaluate potential partners and structure relationships for long-term success.
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="flex items-center mb-4">
                <Shield className="h-6 w-6 text-red-500 mr-3" />
                <h3 className="text-xl font-medium">Business owners who want to protect existing partnerships</h3>
              </div>
              <p className="text-gray-600">
                Strengthen your current relationships with improved communication and governance structures.
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="flex items-center mb-4">
                <BarChart4 className="h-6 w-6 text-blue-500 mr-3" />
                <h3 className="text-xl font-medium">Investors evaluating team dynamics in potential opportunities</h3>
              </div>
              <p className="text-gray-600">
                Spot partnership red flags before investing and help portfolio companies build stronger foundations.
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl">
              <div className="flex items-center mb-4">
                <Heart className="h-6 w-6 text-pink-500 mr-3" />
                <h3 className="text-xl font-medium">Professionals recovering from partnership disasters</h3>
              </div>
              <p className="text-gray-600">
                Rebuild your confidence and develop strategies to prevent similar situations in the future.
              </p>
            </div>
            
            <div className="bg-gray-50 p-8 rounded-xl md:col-span-2">
              <div className="flex items-center mb-4">
                <UserCheck className="h-6 w-6 text-green-500 mr-3" />
                <h3 className="text-xl font-medium">Anyone who wants to build successful, sustainable business relationships</h3>
              </div>
              <p className="text-gray-600">
                Learn the principles of healthy business relationships that can be applied across various contexts.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookAudience;
